import jquery from 'jquery';
import wwdev from '@wwdev/functions';
import * as bootstrap from 'bootstrap';

window.$ = window.jQuery = window.jquery = jquery;
window.wwdev = wwdev;
window.bootstrap = bootstrap;

$.ajaxSetup({
	beforeSend: function(xhr, settings) {
		const url = settings.url;
		const currentDomain = window.location.hostname;

		// Parse URL om te checken of het intern is
		let isInternal = true;
		if (url.startsWith('http://') || url.startsWith('https://')) {
			try {
				const urlObj = new URL(url);
				isInternal = urlObj.hostname === currentDomain;
			} catch (e) {
				isInternal = false;
			}
		}

		// Alleen CSRF voor interne requests
		if (isInternal) {
			const token = $('meta[name="csrf-token"]').attr('content');
			if (token) {
				xhr.setRequestHeader('X-CSRF-TOKEN', token);
			}
		}
	}
});